module.exports = __webpack_public_path__ + "static/media/video_normal_small_480.35f0319.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/video_normal_small_480.mp4
// module id = 3vNI
// module chunks = 1